import { normalizeCustomerNumberForLookup } from '../helpers/dealer-customer-input';

/** Passed via React Router `location.state` when opening dealer-portal flows from Dealer inventory only. */
export type TDealerPortalNavState = {
	fromDealerInventory: true;
};

export function isDealerPortalNavFromInventory(state: unknown): state is TDealerPortalNavState {
	return (
		typeof state === 'object' &&
		state !== null &&
		(state as TDealerPortalNavState).fromDealerInventory === true
	);
}

/** `/admin/dealer-inventory` with optional `customerNumber` query (normalized) so returning from orders/invoices restores the dealer. */
export function dealerInventorySearchPath(customerNumber: string | null | undefined): string {
	if (!customerNumber?.trim()) return '/admin/dealer-inventory';
	const n = normalizeCustomerNumberForLookup(customerNumber);
	if (!n) return '/admin/dealer-inventory';
	return `/admin/dealer-inventory?customerNumber=${encodeURIComponent(n)}`;
}
